export default "__VITE_ASSET__O21kKlyl__"